import React, { FC } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { StepTemplate } from '../../components/styled/stepTemplate/StepTemplate'
import { Button } from '../../components/styled/CosmaButton/CosmaButton'
import { Progress } from '../../@types/progress'
import { getCustomDimensionForIntent } from '../../tracking/tracking'
import { reportTrackingEvent } from '../../tracking/thunks'
import { useReportViewEvent } from '../../hooks'
import { Intent } from '../../@types/intent'
import { updateIntent } from '../../store/lead/leadSlice'
import { PartialSaleStepIcon } from '../../components/icons/StepIcons/PartialSaleStepIcon'
import { IntegrationType } from '../../@types/config'
import { ReduxState } from '../../store/reducers'
import './PartialSaleStep.scss'

const tinyColor = require('tinycolor2')

interface PartialSaleStepProps {
  goToNextStep: () => unknown
  goToPreviousStep: () => unknown
  progress: Progress
  displayBack: boolean
}

const headline = 'Haben Sie Interesse an einem Teilverkauf?'

const PartialSaleStep: FC<PartialSaleStepProps> = (props) => {
  useReportViewEvent({ pageTitle: 'partialsale' })
  const {
    config: { theme, integrationType },
  } = useSelector((state: ReduxState) => state)

  const dispatch = useDispatch()

  const goToNextStep = (intent: Intent) => {
    dispatch(updateIntent(intent))
    dispatch(
      reportTrackingEvent({
        label: `partialsale_submit`,
        action: 'realtor-leadengine',
        category: 'residential',
        pageTitle: 'partialsale',
        inputValue: getCustomDimensionForIntent(intent),
        eventName: 'lead_input',
        customDimensions: {
          ga_cd_lead_engine_input_value: getCustomDimensionForIntent(intent),
          ga_cd_rle_intent: getCustomDimensionForIntent(intent),
        },
      })
    )
    props.goToNextStep()
  }

  return (
    <StepTemplate
      icon={<PartialSaleStepIcon />}
      headline={headline}
      displayNext={false}
      goToPreviousStep={props.goToPreviousStep}
      progress={props.progress}
      displayBack={props.displayBack}
      className='partial-sale'
      backgroundColor={theme.background}
      textColor={theme.text}
    >
      <div className={`grid-item one-whole`}>
        <div className='grid-item one-whole'>
          <div className='details-holder one-half mr-auto status-holder justify-center'>
            <ul className='status-list list-check'>
              <li>
                <span className='status-primary-text header-text'>Entspannt wohnen bleiben</span>
                <span className='status-secondary-text header-sub-text'>Lebenslanges Wohn- & Nutzungsrecht</span>
              </li>
              <li>
                <span className='status-primary-text'>Sofortauszahlung</span>
                <span className='status-secondary-text'>Wunschbetrag direkt erhalten</span>
              </li>
              <li>
                <span className='status-primary-text'>Volle Kontrolle behalten</span>
                <span className='status-secondary-text'>Sie bestimmen, was zukünftig mit Ihrer Immobilie passiert</span>
              </li>
            </ul>
            <div className='status-summary palm-hide'>
              <p className='status-primary-text'>
                <i className='back-icon is24-icon-info1 align-middle' />
              </p>
              <p className='status-secondary-text status-description'>
                Bei einem Teilverkauf erhalten Sie eine sofortige Auszahlung für einen Teil Ihrer Immobilie. Von diesem
                können Sie sich lang ersehnte Wünsche erfüllen, während Sie weiterhin in Ihrem Zuhause wohnen.
              </p>
            </div>
          </div>
        </div>
        <div className='grid-item one-whole margin-top-xxl padding-horizontal-l align-center'>
          <Button
            data-testid='error-step-reload-page-button'
            onClick={() => goToNextStep(Intent.PARTIAL_SALE)}
            className='palm-one-whole status-btn'
            appearance='primary'
            primary={theme.primary}
            secondary={theme.secondary}
            textColor={
              integrationType === IntegrationType.EXTERNAL && tinyColor(theme.primary).isDark()
                ? '#FFFFFF'
                : theme?.text
            }
            secondaryLight={theme.secondaryLight}
          >
            Teilverkauf Angebot erhalten
          </Button>
        </div>
        <div className='grid-item one-whole margin-top-m padding-horizontal-l align-center'>
          <a
            href='#/'
            onClick={() => goToNextStep(Intent.INDEPENDENT_SALE)}
            style={{ color: integrationType === IntegrationType.IMMOVERKAUF24 ? '#2780ba' : '#2267e8' }}
          >
            Ich habe kein Interesse
          </a>
        </div>

        <div className='grid-item one-whole margin-top-xxl padding-horizontal-l align-center mr-auto status-mobile'>
          <div className='status-summary mr-auto'>
            <p className='status-primary-text'>
              <i className='back-icon is24-icon-info1 align-middle' />
            </p>
            <p className='status-secondary-text status-description'>
              Bei einem Teilverkauf erhalten Sie eine sofortige Auszahlung für einen Teil Ihrer Immobilie. Von diesem
              können Sie sich lang ersehnte Wünsche erfüllen, während Sie weiterhin in Ihrem Zuhause wohnen.
            </p>
          </div>
        </div>
      </div>
    </StepTemplate>
  )
}

export default PartialSaleStep
